import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Preview Image URL',
  },
  Alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  VideoMobileURL: {
    id: 'Mobile Video URL',
    defaultMessage: 'URL vídeo mòbil (opcional)',
  },
  VideoMobileURLDescription: {
    id: 'Mobile video URL description',
    defaultMessage:
      'Format vertical 9:16, 1080×1920px recomanat (p. ex. YouTube Shorts). Es mostra en pantalles ≤768px.',
  },
});
export const VideoBlockSchema = (props) => ({
  title: props.intl.formatMessage(messages.Video),
  block: 'Video',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      // fields: ['url', 'preview_image', 'align'],
      fields: ['url', 'url_mobile'],
    },
  ],

  properties: {
    url: {
      title: props.intl.formatMessage(messages.VideoURL),
      widget: 'url',
    },
    url_mobile: {
      title: props.intl.formatMessage(messages.VideoMobileURL),
      description: props.intl.formatMessage(messages.VideoMobileURLDescription),
      widget: 'url',
    },
    preview_image: {
      title: props.intl.formatMessage(messages.Preview_image),
      widget: 'url',
    },
    align: {
      title: props.intl.formatMessage(messages.Alignment),
      widget: 'align',
    },
  },
  required: [],
});

export default VideoBlockSchema;
